






















































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BuildAction extends Vue {
  @Prop()
  questionId!: number;

  @Prop()
  isSuperAdmin!: boolean;

  @Prop()
  isPublished!: boolean;

  showDeleteOption = false;

  get isNoQuestionFetched() {
    return this.questionId && this.questionId !== 0 ? false : true;
  }

  toggleDeleteOption() {
    this.showDeleteOption = !this.showDeleteOption;
  }

  updateAction() {
    this.$emit('updateAction');
  }

  publishAction() {
    this.$emit('publishAction');
  }

  unpublishAction() {
    this.$emit('unpublishAction');
  }

  createDraftAction() {
    this.$emit('createDraftAction');
  }

  createPublishAction() {
    this.$emit('createPublishAction');
  }

  deleteQuestion() {
    this.$emit('deleteQuestion');
  }
}
